/* @flow */
import PropTypes from 'prop-types';
import * as React from 'react';
import { getPropClassesFromInstance } from 'lib/getPropClasses';
import cx from 'classnames';
import './styles/FormSingle.scss';

/**
 * ## An [Input](/internal/components/Input) with an attached [Button](/internal/components/Button).
 * ### Used for simple, single-field forms.
 *
 * ```example
 * <FormSingle>
 *   <Input placeholder="Input" />
 *   <Button>Button</Button>
 * </FormSingle>
 * ```
 *
 * ```example
 * <FormSingle reset="mobile">
 *   <Input placeholder="Input" />
 *   <Button>Button</Button>
 * </FormSingle>
 * ```
 */

class FormSingle extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    children(props: Object, propName: string) {
      if (React.Children.count(props[propName]) !== 2) {
        return new Error('FormSingle expects two child elements');
      }
      return undefined;
    },
    reset: PropTypes.oneOf(['mobile']),
  };

  static propClasses = {
    reset: {
      mobile: 'FormSingle--reset--mobile',
    },
  };

  render() {
    const { children, className } = this.props;

    return (
      <div className={cx('FormSingle', className, getPropClassesFromInstance(this))}>
        {children}
      </div>
    );
  }
}

export default FormSingle;
